import api from './api'

/**
 * Site settings module — logo/favicon/colors, header nav, footer, and the
 * public homepage's hero/features/modules. GET is public (no auth, powers
 * Home.vue before login); the PUT/upload endpoints require F10 write.
 */
export const siteSettingsService = {
  async getAll() {
    const { data } = await api.get('/site-settings')
    return data.data
  },

  async updateBranding(payload) {
    const { data } = await api.put('/site-settings/branding', payload)
    return data.data
  },

  async updateHeader(payload) {
    const { data } = await api.put('/site-settings/header', payload)
    return data.data
  },

  async updateFooter(payload) {
    const { data } = await api.put('/site-settings/footer', payload)
    return data.data
  },

  async updateLogin(payload) {
    const { data } = await api.put('/site-settings/login', payload)
    return data.data
  },

  async updateHomepage(payload) {
    const { data } = await api.put('/site-settings/homepage', payload)
    return data.data
  },

  async uploadImage(file) {
    const form = new FormData()
    form.append('file', file)
    const { data } = await api.post('/uploads', form, { headers: { 'Content-Type': 'multipart/form-data' } })
    return data.data.url
  }
}
